function sortEventsList(container) {
  const cards = Array.from(container.querySelectorAll('.events-list__card'));
  if (cards.length <= 1) return;

  const getTs = (el) => {
    const n = Number.parseInt(el.dataset.eventTs || '0', 10);
    return Number.isFinite(n) ? n : 0;
  };

  const isPast = (el) => el.dataset.eventPast === 'true';

  cards.sort((a, b) => {
    const aPast = isPast(a) ? 1 : 0;
    const bPast = isPast(b) ? 1 : 0;
    if (aPast !== bPast) return aPast - bPast; // upcoming first, past last

    const aTs = getTs(a);
    const bTs = getTs(b);
    return bTs - aTs; // latest date first
  });

  for (const card of cards) container.appendChild(card);
}

function initEventsLists() {
  document.querySelectorAll('.events-list__items').forEach(sortEventsList);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEventsLists);
} else {
  initEventsLists();
}

